import { Plus, Trash2 } from "lucide-react";
import { AutoTextarea } from "./AutoTextarea";

export function NotesEditor({ title, notes, onChange, readOnly, testId }) {
  const list = notes || [];
  const setAt = (i, v) => onChange(list.map((n, j) => (j === i ? v : n)));
  return (
    <div className="space-y-2" data-testid={testId}>
      <h3 className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">{title}</h3>
      {list.length === 0 && <p className="text-xs text-slate-400">No notes.</p>}
      {list.map((n, i) => (
        <div key={i} className="flex gap-2 items-start">
          <span className="mt-2 w-5 text-xs font-semibold text-slate-400 tabular-nums">{i + 1}.</span>
          <div className="flex-1"><AutoTextarea value={n} onChange={(v) => setAt(i, v)} readOnly={readOnly} minRows={1} testId={`${testId}-note-${i}`} /></div>
          {!readOnly && (
            <button type="button" onClick={() => onChange(list.filter((_, j) => j !== i))} className="mt-2 text-slate-400 hover:text-red-600" title="Remove note" data-testid={`${testId}-remove-${i}`}>
              <Trash2 className="h-4 w-4" />
            </button>
          )}
        </div>
      ))}
      {!readOnly && (
        <button type="button" onClick={() => onChange([...list, ""])} className="text-xs font-medium text-brillien-600 hover:text-brillien-700 inline-flex items-center gap-1" data-testid={`${testId}-add`}>
          <Plus className="h-3.5 w-3.5" />Add note
        </button>
      )}
    </div>
  );
}
